const COMPARE_FIELDS = [
  'split_no',
  'planned_qty',
  'supplier_response_due_date',
  'shipment_date',
  'arrival_date',
  'adjustment_memo',
  'shipping_preparation',
];

export const SPLIT_PLAN_LATEST_FIELDS = [
  'latest_shipment_date',
  'latest_supplier_response_due_date',
  'latest_arrival_date',
];

export function normalizeSplitPlanDate(value) {
  if (value == null || value === '') return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return value.toISOString().split('T')[0];
  }
  const text = String(value).trim();
  if (!text) return null;
  return text.slice(0, 10);
}

function normalizeCompareValue(field, value) {
  if (
    field === 'supplier_response_due_date' ||
    field === 'shipment_date' ||
    field === 'arrival_date'
  ) {
    return normalizeSplitPlanDate(value);
  }
  if (value == null || value === '') return null;
  return value;
}

function asPlanList(splitPlans) {
  return Array.isArray(splitPlans) ? splitPlans : [];
}

export function areSplitPlansEqual(a, b) {
  const left = asPlanList(a)
    .slice()
    .sort((x, y) => (x.split_no || 0) - (y.split_no || 0));
  const right = asPlanList(b)
    .slice()
    .sort((x, y) => (x.split_no || 0) - (y.split_no || 0));
  if (left.length !== right.length) return false;
  for (let i = 0; i < left.length; i += 1) {
    for (const field of COMPARE_FIELDS) {
      if (normalizeCompareValue(field, left[i][field]) !== normalizeCompareValue(field, right[i][field])) {
        return false;
      }
    }
  }
  return true;
}

function maxDateField(plans, field) {
  let latest = null;
  for (const plan of plans) {
    const key = normalizeSplitPlanDate(plan[field]);
    if (!key) continue;
    if (!latest || key > latest) latest = key;
  }
  return latest;
}

export function latestSplitPlanDates(splitPlans) {
  const plans = asPlanList(splitPlans);
  return {
    latest_shipment_date: maxDateField(plans, 'shipment_date'),
    latest_supplier_response_due_date: maxDateField(plans, 'supplier_response_due_date'),
    latest_arrival_date: maxDateField(plans, 'arrival_date'),
  };
}

export function mergeSplitPlansIntoItem(item, splitPlans, latestFields) {
  const latest = latestSplitPlanDates(splitPlans);
  const nextLatest = {};
  let latestChanged = false;
  for (const field of latestFields) {
    const value = latest[field] ?? null;
    nextLatest[field] = value;
    if (normalizeSplitPlanDate(item[field]) !== normalizeSplitPlanDate(value)) {
      latestChanged = true;
    }
  }
  if (areSplitPlansEqual(item.split_plans, splitPlans) && !latestChanged) {
    return item;
  }
  return {
    ...item,
    split_plans: splitPlans,
    ...nextLatest,
  };
}

export function patchItemsSplitPlans(prevItems, rowId, getRowId, splitPlans, latestFields) {
  let changed = false;
  const next = prevItems.map((item) => {
    if (getRowId(item) !== rowId) return item;
    const updated = mergeSplitPlansIntoItem(item, splitPlans, latestFields);
    if (updated === item) return item;
    changed = true;
    return updated;
  });
  return changed ? next : prevItems;
}
